import cx from 'classnames';
import { CatListItem } from '@blocks-react/components/ListItem';
import { FC } from 'react';
import { HeaderCartListItemProps } from './types';
import styles from './HeaderCartListItem.module.scss';

export const HeaderCartListItem: FC<HeaderCartListItemProps> = ({
  item,
  quantityLabel,
  onClick
}) => {
  return (
    <CatListItem href={item.seoURL} data-testid="cat-cart-list-item" onClick={onClick}>
      <div className="d-flex">
        <img
          src={`${item.imageURL}?wid=61&hei=61&fmt=png-alpha`}
          height="61px"
          width="61px"
          loading="lazy"
          alt={item.name}
          className={cx('me-3', styles['header__cart-list-item--image'])}
        />
        <div>
          <p
            className={cx(
              'my-1 text-break',
              styles['header__cart-list-item--name']
            )}
          >
            {item.partNumber}: {item.name}
          </p>
          <p className="mb-0">
            {quantityLabel} {item.quantity}
          </p>
        </div>
      </div>
    </CatListItem>
  );
};
